import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://findmymusicgurukul.onrender.com/api';


const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

// Request Interceptor: Attach Auth Token if available
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('music_guru_auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Simplify response payload & handle errors
axiosClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const customError = {
      message: error.response?.data?.message || error.message || 'An unexpected error occurred.',
      status: error.response?.status,
      data: error.response?.data,
      response: error.response
    };
    return Promise.reject(customError);
  }
);

export default axiosClient;
